/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-25 10:06:15
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-30 16:33:17
 * @FilePath: \hlweb2.0\src\pages\Solution\Archives\Carousel\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useRef } from "react";
import { Carousel, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./index.scss";
function InfoServicesCarousel() {
  const carouselRef = useRef();
  const { t } = useTranslation();
  const infoServicesCarouselCenter = t("solution_infoServices.infoServices4", {
    returnObjects: true,
  });
  return (
    <div className="infoServicesCarousel_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{infoServicesCarouselCenter.til}</div>
          <span>{infoServicesCarouselCenter.dil}</span>
        </div>
      </div>
      <div className="infoServicesCarousel_btn">
        <div
          className="infoServicesCarousel_left"
          onClick={() => carouselRef.current.prev()}
        >
          <img
            src={
              require("../../../../assets/images/solution/toLeft.png").default
            }
            alt=""
          />
        </div>
        <div
          className="infoServicesCarousel_right"
          onClick={() => carouselRef.current.next()}
        >
          <img
            src={
              require("../../../../assets/images/solution/toRight.png").default
            }
            alt=""
          />
        </div>
      </div>
      <Carousel
        ref={carouselRef}
        className="infoServicesCarousel_con"
        dots={false}
        infinite={true}
        slidesToShow={4} // 一页显示5个
        slidesToScroll={1} // 每次滚动1个
        //   autoplay={true}
        //   pauseOnHover={true} // 鼠标悬停暂停
        //   swipeToSlide={true} // 支持拖动滑动
        //   draggable={true}
      >
        {infoServicesCarouselCenter.contractList.map((item, index) => {
          return (
            <div
              className="infoServicesCarousel_li"
              key={index}
              style={{ width: "80% !important" }}
            >
              <div className="infoServicesCarousel_img">
                <img src={infoServicesCarouselCenter.icon} alt="" />
              </div>

              <Tooltip title={item.title}>
                <div className="infoServicesCarousel_title">{item.title}</div>
              </Tooltip>
              <Tooltip title={item.detail}>
                <div className="infoServicesCarousel_detail">{item.detail}</div>
              </Tooltip>

              {/* <div className="infoServicesCarousel_detail">{item.detail}</div> */}
              <div className="infoServicesCarousel_list">
                <div className="list_title">
                  {infoServicesCarouselCenter.title2}：
                </div>
                {item.list.map((item1, index1) => {
                  return (
                    <div className="list_item" key={index1}>
                      <img src={infoServicesCarouselCenter.icon2} alt="" />
                      <Tooltip title={item1}>
                        <div className="list_con">{item1}</div>
                      </Tooltip>
                    </div>
                  );
                })}
              </div>
              <div className="infoServicesCarousel_labelBox">
                <Tooltip title={item.label}>
                  <div className="infoServicesCarousel_label">{item.label}</div>
                </Tooltip>
              </div>

            </div>
          );
        })}
      </Carousel>
    </div>
  );
}

export default InfoServicesCarousel;
